import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import Select from 'react-select';

// import 'react-select/dist/react-select.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class SelectBox extends Component {

    constructor (props) {
        super(props);

        // this.state = {
        //     selectedOption: this.props.selected? this.props.selected: '',
        // }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(selectedOption, onChange) {
        // this.setState({selectedOption});

        if (typeof this.props.onSelected !== "undefined") {
            this.props.onSelected(selectedOption);
        }
        if (onChange && typeof onChange !== "undefined") {
            onChange(selectedOption);
        }
    }

    render() {

        const {input, options, menuContainerStyle, onChange, selected, selectedOption, styles, isClearable, isSearchable, placeholder, className} = this.props; //style
        // const { selectedOption } = this.state;
        const defaultValue = selected || selectedOption // && selectedOption.value;
        const cleanOptions = _.filter(options, (op) => op);
        return (
            <Select
                name={input? input.name: input} 
                defaultValue={defaultValue} 
                onChange={(v) => {this.handleChange(v, input? input.onChange: (onChange? onChange: undefined))}}
                options={cleanOptions} 
                styles={styles}
                // style={style? style: {borderRadius: "0", border: "1px solid #979797"}}
                menuContainerStyle={menuContainerStyle? menuContainerStyle: {borderRadius: "0", border: "1px solid #979797"}}
                isClearable={isClearable || false}
                isSearchable={isSearchable || false}
                arrowRenderer={() => {return <span className="caret"><FontAwesomeIcon icon={["fal", "chevron-down"]} /></span>}}
                className={`react-select-container${className? " " + className: ''}`}
                classNamePrefix="react-select"
                placeholder={placeholder || ""}
            />
        );
    }
}

function mapStateToProps(state) {
    return {}
}
export default connect(mapStateToProps, {})(SelectBox)